<template>
  <div
    class="detail-full-credits"
    data-cy="full-credits"
  >
    <UnderlinedTitle
      tag="h2"
      tag-class="h5"
      :title="$t('credits.title')"
    />
    <div class="credits-container">
      <dl
        v-for="(items, label) in creditsGroupByFunction"
        :key="label"
      >
        <dt v-html="items[0].function" />
        <dd
          v-for="item in items"
          :key="item.slug"
          v-html="`${item.first_name} ${item.last_name}`"
        />
      </dl>
    </div>
  </div>
</template>

<script>
import groupBy from 'lodash/groupBy'
import filter from 'lodash/filter'
import UnderlinedTitle from '@components/UnderlinedTitle'

export default {
  name: 'DetailFullCredits',
  components: {
    UnderlinedTitle
  },
  props: {
    credits: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    creditsGroupByFunction () {
      return groupBy(filter(this.credits, credit => credit.function !== null), 'function')
    }
  }
}
</script>

<style lang="less" scoped>
@import (reference) "~@less/shared/utilities.less";

.credits-container {
  .small-box-vertical-margin;
  @media (min-width: @screen-sm-min) {
    column-count: 2;
  }
  @media (min-width: @screen-md-min) {
    column-count: 3;
  }
  @media (min-width: @screen-lg-min) {
    column-count: 5;
  }
}

dl {
  margin-bottom: @box-padding * 0.5;
  font-family: @font-sans-serif;
  break-inside: avoid-column;
}

dt {
  text-transform: uppercase;
  font-weight: normal;
}

</style>
